var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contract-doc-selector" },
    [
      _c(
        "div",
        {
          ref: "activator",
          staticClass: "contract-doc-selector__activator",
          class: {
            "contract-doc-selector__activator--disabled": _vm.isDisabled,
          },
        },
        [
          _c("AppIcon", {
            key: _vm.statusIconName,
            staticClass: "contract-doc-selector__status-icon",
            style: { color: _vm.statusIconColor },
            attrs: { name: _vm.statusIconName },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "contract-doc-selector__text" }, [
            _c("span", { staticClass: "contract-doc-selector__title" }, [
              _vm._v(_vm._s(_vm.selectedContract?.contract_name)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "contract-doc-selector__subtitle" }, [
              _vm._v(_vm._s(_vm.selectedContract?.outsourcer)),
            ]),
          ]),
          _vm._v(" "),
          !_vm.isDisabled
            ? _c("AppIcon", {
                staticClass: "contract-doc-selector__arrow",
                class: { "contract-doc-selector__arrow--rotated": _vm.isOpen },
                attrs: { src: "doc-chevron-down.svg" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isDisabled
        ? _c(
            "BaseTooltip",
            {
              staticClass: "contract-doc-selector__dropdown",
              attrs: {
                for: "activator",
                trigger: "click",
                placement: "bottom-start",
                arrow: false,
                interactive: true,
                offset: 4,
                "append-to": "body",
                "hide-on-click": "",
              },
              on: {
                open: _vm.onDropdownOpen,
                close: function ($event) {
                  _vm.isOpen = false
                },
              },
            },
            _vm._l(_vm.contracts, function (item) {
              return _c(
                "div",
                {
                  key: item.contract_id,
                  staticClass: "contract-doc-selector__item",
                  attrs: { "hide-on-select": "" },
                  on: {
                    click: function ($event) {
                      return _vm.selectContract(item.contract_id)
                    },
                  },
                },
                [
                  _c("AppIcon", {
                    key: _vm.getStatusIconName(_vm.itemStatus(item)),
                    staticClass: "contract-doc-selector__item-status",
                    style: {
                      color: _vm.getStatusIconColor(_vm.itemStatus(item)),
                    },
                    attrs: {
                      name: _vm.getStatusIconName(_vm.itemStatus(item)),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "contract-doc-selector__item-text" },
                    [
                      _c(
                        "span",
                        { staticClass: "contract-doc-selector__item-title" },
                        [_vm._v(_vm._s(item.contract_name))]
                      ),
                      _vm._v(" "),
                      item.outsourcer
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "contract-doc-selector__item-subtitle",
                            },
                            [_vm._v(_vm._s(item.outsourcer))]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  item.contract_id === _vm.selectedId
                    ? _c("AppIcon", {
                        staticClass: "contract-doc-selector__item-check",
                        attrs: { src: "doc-check-selected.svg" },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }